import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.9902 0.932405C19.1552 1.07487 19.25 1.28205 19.25 1.50001V9C19.25 9.41422 18.9142 9.75 18.5 9.75H10C9.58579 9.75 9.25 9.41422 9.25 9V2.75001C9.25 2.37794 9.52277 2.06212 9.89088 2.00799L18.3909 0.757986C18.6065 0.726274 18.8253 0.789938 18.9902 0.932405ZM10.75 3.39778V8.25001H17.75V2.36837L10.75 3.39778ZM8.49023 2.47652C8.65518 2.61899 8.75 2.82617 8.75 3.04412V9C8.75 9.41422 8.41421 9.75 8 9.75H1.5C1.08579 9.75 0.75 9.41422 0.75 9V4.00001C0.75 3.62794 1.02277 3.31212 1.39088 3.25799L7.89088 2.3021C8.10652 2.27039 8.32528 2.33406 8.49023 2.47652ZM2.25 4.64778V8.25001H7.25V3.91248L2.25 4.64778ZM0.75 11C0.75 10.5858 1.08579 10.25 1.5 10.25H8C8.41421 10.25 8.75 10.5858 8.75 11V16.9559C8.75 17.1738 8.65518 17.381 8.49023 17.5235C8.32528 17.666 8.10652 17.7296 7.89088 17.6979L1.39088 16.742C1.02277 16.6879 0.75 16.3721 0.75 16V11ZM2.25 11.75V15.3522L7.25 16.0875V11.75H2.25ZM9.25 11C9.25 10.5858 9.58579 10.25 10 10.25H18.5C18.9142 10.25 19.25 10.5858 19.25 11V18.5C19.25 18.718 19.1552 18.9251 18.9902 19.0676C18.8253 19.2101 18.6065 19.2737 18.3909 19.242L9.89088 17.992C9.52277 17.9379 9.25 17.6221 9.25 17.25V11ZM10.75 11.75V16.6022L17.75 17.6316V11.75H10.75Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }